<template>
  <v-container fluid>
    <mp-external-form  ref="externalForm" target="_self" />
    <!-- アカウントをお持ちの方 -->
    <v-row justify="center">
      <v-col cols="12" md="8">
        <h1>{{$t("message.login.title.member")}}</h1>
      </v-col>
    </v-row>

    <!-- 認証エラー -->
    <v-row justify="center" v-if="view.authErrors.length > 0">
      <v-col cols="12" md="8">
        <mp-authError :errors="view.authErrors" />
      </v-col>
    </v-row>

    <!-- エラー -->
    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col md="8" sm="12">
        <mp-error :errors="view.errors" message-key="message.login.error." />
      </v-col>
    </v-row>

    <!-- ID -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label no-color>{{$t("message.login.label.id")}}</mp-label>
      </v-col>
      <v-col cols="8" md="6">
        <v-text-field
          v-model="form.id"
          v-bind:placeholder="$t('message.login.ph.id')"
          id="id"
          hide-details
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- パスワード -->
    <v-row justify="center">
      <v-col cols="4" md="2">
        <mp-label no-color>{{$t("message.login.label.password")}}</mp-label>
      </v-col>
      <v-col cols="8" md="6">
        <v-text-field
          :append-icon="view.show ? 'mdi-eye' : 'mdi-eye-off'"
          :type="view.show ? 'text' : 'password'"
          @click:append="view.show = !view.show"
          v-model="form.password"
          v-bind:placeholder="$t('message.login.ph.password')"
          id="password"
          hide-details
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- ログインボタン -->
    <v-row justify="center">
      <v-col
        class="text-center"
        cols="8" md="3"
      >
        <mp-button wide @click="clickLogin">{{ $t('message.login.button.login') }}</mp-button>
      </v-col>
    </v-row>

    <!-- パスワードを忘れた場合 -->
    <v-row justify="center">
      <v-col cols="12" md="8">
        <p class="text-center">{{$t("message.login.desc.reminder1")}}<router-link to="/reminder">{{$t("message.login.desc.reminder2")}}</router-link>{{$t("message.login.desc.reminder3")}}</p>
      </v-col>
    </v-row>

    <!-- はじめての方 -->
    <v-row justify="center">
      <v-col cols="12" md="8">
        <h1>{{$t("message.login.title.new")}}</h1>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" md="8">
        <div class="text-left">{{$t("message.login.desc.entry1")}}<br>{{$t("message.login.desc.entry2")}}</div>
      </v-col>
    </v-row>

    <!-- アカウント申請ボタン -->
    <v-row justify="center">
      <v-col
        class="text-center"
        cols="8"
        md="3"
      >
        <mp-button wide @click="clickEntry">{{ $t('message.login.button.entry') }}</mp-button>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import MpLabel from '@/components/item/MpLabel.vue'
import MpAuthError from '@/components/item/MpAuthError.vue'
import MpError from '@/components/item/MpError.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpExternalForm from '@/components/item/MpExternalForm.vue'
import Cookies from 'js-cookie'
import constantValue from '@/constantValue'
import RedirectMixin from '@/mixins/redirect'
import IECheckMixin from '@/mixins/iecheck'

export default {
  name: 'login',
  components: {
    MpLabel,
    MpButton,
    MpAuthError,
    MpError,
    MpExternalForm
  },
  data: () => ({
    transitionUrl: null,
    view: {
      show: false,
      authErrors: [],
      errors: []
    },
    form: {
      id: null,
      password: null
    }
  }),
  computed: {
  },
  mixins: [RedirectMixin, IECheckMixin],
  methods: {
    async loadViewData () {
      const error = this.$route.params
      if (error.messages && error.messages.length > 0) {
        this.view.authErrors = error.messages
      }
    },
    async clickLogin (ev) {
      // エラークリア
      this.view.authErrors = []
      this.view.errors = []

      await this.$store.dispatch('login', { id: this.form.id, password: this.form.password })
        .then(async () => {
          const targetUrl = !this.transitionUrl ? null : (await this.getTransitionUrl(this.transitionUrl))

          if (this.$store.state.auth.tempPasswordAuthFlg) {
            this.$router.push({ path: '/change-password' })
          } else {
            if (targetUrl) {
              this.$refs.externalForm.doSubmit(targetUrl)
            } else {
              this.$router.push({ path: '/' })
            }
          }
        })
        .catch(error => {
          this.view.errors = error.messages
        })
    },
    clickEntry (ev) {
      this.$router.push({ path: '/account/entry' })
    }
  },
  created: function () {
    this.transitionUrl = Cookies.get(constantValue.cookieKeyForTransitionalUrl) || ''
    Cookies.remove(constantValue.cookieKeyForTransitionalUrl)
    this.loadViewData()
  },
  mounted: function () {
    this.alertIfIE()
  }
}
</script>
